import React from 'react'

const AgreeIcons = ({ children }) => {
  return (
    <div className='agreeIcons'>
       {children}
    </div>
  )
}

export default AgreeIcons